module.exports = __webpack_public_path__ + "static/media/side-page.a4dd7622.jpg";